import { PAYMENT_GATEWAY } from '@/constants'

// Feature flag: enables temporary demo bridge of payment type via query between
// ticketing and OM domains. Set to false to fully disable this behavior.
export const ENABLE_TICKETING_PAYMENT_TYPE_QUERY_BRIDGE = true

export const TICKETING_PAYMENT_TYPE_QUERY_KEY = 'selectedPaymentType'
export const TICKETING_PAYMENT_TYPE_STORAGE_KEY = 'ticketingSelectedPaymentType'

const ALLOWED_PAYMENT_TYPES = [
	PAYMENT_GATEWAY.CREDIT_CARD,
	PAYMENT_GATEWAY.APPLE_PAY_CARD,
	PAYMENT_GATEWAY.ANDROID_PAY_CARD
]

export const normalizeTicketingPaymentType = (paymentType: string): string => {
	return ALLOWED_PAYMENT_TYPES.includes(paymentType) ? paymentType : ''
}
